import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "utils/Helper";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

const SkeletonLine = styled.div`
  height: 18px;
  background-color: #2e3136;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite ease-in-out;
  width: ${props => props.width || "100%"};
`;

const UserAgreement = () => {
  const { data: page, isLoading } = useQuery({
    queryKey: ["cmsPage", "user_agreement"],
    queryFn: async () => {
      const res = await axios.get(`${API}/cms-pages/user_agreement`);
      return res.data?.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes cache
  });

  if (isLoading) {
    return (
      <SkeletonWrapper>
        <SkeletonLine width="50%" style={{ height: "28px", marginBottom: "15px" }} />
        <SkeletonLine width="100%" />
        <SkeletonLine width="95%" />
        <SkeletonLine width="90%" />
        <br />
        <SkeletonLine width="40%" style={{ height: "24px", marginBottom: "10px" }} />
        <SkeletonLine width="98%" />
        <SkeletonLine width="92%" />
        <SkeletonLine width="85%" />
      </SkeletonWrapper>
    );
  }

  if (!page) {
    return (
      <p className="text-white font-light mb-2 font-14 l30 mb-4">
        Failed to load user agreement.
      </p>
    );
  }

  return (
    <div 
      className="text-white font-light mb-2 font-14 l30 mb-4 cms-content-render"
      dangerouslySetInnerHTML={{ __html: page.content }}
    />
  );
};

export default UserAgreement;
